import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import * as Moment from 'moment-timezone';
import {take} from 'rxjs/operators';
import {RequisitionSignature} from '../../models/signature';
import {RequisitionService} from '../../services/requisition.service';
import {OrdersService} from "../../services/orders.service";

@Component({
  selector: 'app-signature-viewer',
  templateUrl: './signature-viewer.component.html',
  styleUrls: ['./signature-viewer.component.scss'],
})
export class SignatureViewerComponent implements OnChanges {
  @Input() public requisitionId?: number;
  @Input() public orderId?: number;
  @Input() public signature?: RequisitionSignature;

  constructor(private sanitizer: DomSanitizer, private requisitionService: RequisitionService, private orderService: OrdersService) {
  }

  public get SignatureDate() {
    if (!this.signature) {
      return '';
    }
    const tz = Moment.tz.guess();
    return Moment(this.signature.signedDateTime).format('LLLL');
  }

  public get HasImage(): boolean {
    if (!this.signature) {
      return false;
    }
    if (!this.signature.signature) {
      return false;
    }
    return !(!this.signature.signature || this.signature.signature.imageSignature === '');
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.signature && changes.signature.currentValue && !this.requisitionId) {
      if (this.signature && this.signature.signature && this.signature.signature.imageSignature) {
        this.signature.signature.imageSignature = this.signature.signature.imageSignature.includes('data:image') ? this.signature.signature.imageSignature :
          this.sanitizer.bypassSecurityTrustResourceUrl('data:image;base64,' + this.signature.signature.imageSignature) as any;
      }
    }

    if (changes.requisitionId && changes.requisitionId.currentValue) {
      this.requisitionService.requisitionSignature(this.requisitionId as number)
        .pipe(take(1))
        .subscribe(value => {
          this.signature = value;
          if (this.signature?.signature?.imageSignature && this.signature.signature.imageSignature !== '') {
            this.signature.signature.imageSignature = this.sanitizer
              .bypassSecurityTrustResourceUrl('data:image;base64,' + this.signature.signature.imageSignature) as any;
          }
        });
    }

    if (changes.orderId && changes.orderId.currentValue) {
      this.orderService.orderSignature(this.orderId as number)
        .pipe(take(1))
        .subscribe(value => {
          this.signature = value;
          if (this.signature?.signature?.imageSignature && this.signature.signature.imageSignature !== '') {
            this.signature.signature.imageSignature = this.sanitizer
              .bypassSecurityTrustResourceUrl('data:image;base64,' + this.signature.signature.imageSignature) as any;
          }
        });
    }
  }
}
